// @flow
import { connect } from 'react-redux';

import DomainInput from '../../components/DomainInput';
import type { FullState } from '../../types';
import { submitSearch } from '../modules/actions/suggestions';
import {
  selectSearchFirstResultLoading,
  selectSearchValue,
} from '../modules/selectors/search';

const mapStateToProps = (state: FullState) => ({
  value: selectSearchValue(state),
  loading: selectSearchFirstResultLoading(state),
});

const mapDispatchToProps = {
  submitSearch,
};

// $FlowFixMe[underconstrained-implicit-instantiation]
export default (connect(
  mapStateToProps,
  mapDispatchToProps,
  // $FlowFixMe[cannot-resolve-name]
)(DomainInput): Class<ConnectedComponent<mixed, any>> & any);
